<template>
  <div class="lxn-w100" @click="$emit('hubClicked')">
    <div class="AddNewDeviceHub lxn-w100 lxn-margin-auto lxn-pos-rel lxn-border-round lxn-overflow-hidden">
      <div :style="labelStyle" :class="$store.getters.language.floatClass" class="AddNewDeviceHub-right-label lxn-h100">
      </div>
      <div :class="$store.getters.language.floatClass" class="AddNewDeviceHub-left lxn-h100">
        <div :class="[$store.getters.language.floatClass, $store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.font]" class="AddNewDeviceHub-left-texts lxn-h100 lxn-overflow-hidden">
          {{hub.name}}
          <br/>
          {{$store.getters.language.texts.Devices_Hub_IP}}:
          <span class="lxn-text-en">
            {{ipAddress}}
          </span>
          <br/>
          {{$store.getters.language.texts.Devices_Hub_Priviledge}}: {{accessLevel}}
        </div>
        <div :class="$store.getters.language.floatClass" class="AddNewDeviceHub-left-buttons lxn-h100">
          <div class="AddNewDeviceHub-top-buttons lxn-w100">
            <div :class="$store.getters.language.floatClassReverse">
              <ButtonIcon v-if="connectionStatus == 'Local'" :size="25" bgColor="#3BB878" icon="local" iconColor="#ffffff" :padding="5" />
              <ButtonIcon v-else-if="connectionStatus == 'Online'" :size="25" bgColor="#3BB878" icon="online" iconColor="#ffffff" :padding="5" />
              <ButtonIcon v-else-if="connectionStatus == 'Connecting'" :size="25" bgColor="#F1BC52" icon="offline" iconColor="#ffffff" :padding="5" />
              <ButtonIcon v-else :size="25" bgColor="#53636C" icon="offline" iconColor="#ffffff" :padding="5" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonIcon from '@/components/ButtonIcon.vue'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'Hub',
  props: {
    index: Number
  },
  components: {
    ButtonIcon
  },
  data: function () {
    return {
      hub: this.$store.state.hubs[this.index]
    }
  },
  computed: {
    connectionStatus: function () {
      if(this.hub.connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        return 'Local';
      }else if(this.hub.connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTED){
        return 'Online';
      }else if(this.hub.connectionStatus.local == CONFIGS.HUB_CONNECTION_STATUS_CONNECTING || this.hub.connectionStatus.online == CONFIGS.HUB_CONNECTION_STATUS_CONNECTING){
        return 'Connecting';
      }else{
        return 'Offline';
      }
    },
    labelStyle: function () {
      return "background-color: " + this.$store.state.themeMainColors[this.hub.color];
    },
    showNodesButtonIcon: function () {
      return this.showNodes ? 'up' : 'down';
    },
    accessLevel: function () {
      return this.hub.isOwner ? this.$store.getters.language.texts.Devices_Hub_accessOwner : this.$store.getters.language.texts.Devices_Hub_accessNormal
    },
    ipAddress: function () {
      return this.hub.ipAddress ? this.hub.ipAddress : 'xx.xx.xx.xx'
    }
  },
  methods: {
  }
}
</script>

<style>
  .AddNewDeviceHub {
    height: 80px;
    z-index: 1;
    margin-bottom: 5px;
    background-color: #ECECEC;
  }
  .AddNewDeviceHub-right-label {
    width: 8px;
  }
  .AddNewDeviceHub-left {
    width: calc(100% - 8px);
    padding: 10px;
  }
  .AddNewDeviceHub-left-texts {
    width: calc(100% - 55px);
    line-height: 20px;
  }
  .AddNewDeviceHub-left-buttons {
    width: 55px;
  }
  .AddNewDeviceHub-top-buttons {
    height: 30px;
  }
</style>
